import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/258869689262', '_blank');
  };

  const handleInstagramClick = () => {
    window.open('https://www.instagram.com/mundo__crocs?igsh=MTRmdHdncDJoMDN2Ng%3D%3D&utm_source=qr', '_blank');
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className={`w-12 h-12 flex items-center justify-center rounded-full ${
              isScrolled ? 'bg-gradient-to-br from-orange-500 to-pink-500' : 'bg-white/20'
            }`}>
              <i className={`ri-footprint-line text-2xl ${isScrolled ? 'text-white' : 'text-white'}`}></i>
            </div>
            <h1 className={`text-2xl font-bold ${isScrolled ? 'text-gray-900' : 'text-white drop-shadow-lg'}`}>
              Mundo Crocs
            </h1>
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={scrollToTop}
              className={`font-semibold transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:text-orange-600' : 'text-white hover:text-orange-200 drop-shadow-md'
              }`}
            >
              Início
            </button>
            <a
              href="#produtos"
              className={`font-semibold transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:text-orange-600' : 'text-white hover:text-orange-200 drop-shadow-md'
              }`}
            >
              Produtos
            </a>
            <a
              href="#sobre"
              className={`font-semibold transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:text-orange-600' : 'text-white hover:text-orange-200 drop-shadow-md'
              }`}
            >
              Sobre
            </a>
            <button
              onClick={handleWhatsAppClick}
              className={`font-semibold transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:text-orange-600' : 'text-white hover:text-orange-200 drop-shadow-md'
              }`}
            >
              Contacto
            </button>
            <button
              onClick={handleInstagramClick}
              className={`w-10 h-10 flex items-center justify-center rounded-full transition-all cursor-pointer ${
                isScrolled ? 'bg-gradient-to-br from-pink-500 to-purple-600 text-white hover:shadow-lg' : 'bg-white/20 text-white hover:bg-white/30'
              }`}
            >
              <i className="ri-instagram-line text-xl"></i>
            </button>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 py-4 bg-white rounded-2xl shadow-xl">
            <div className="flex flex-col gap-4 px-6">
              <button
                onClick={scrollToTop}
                className="text-left text-gray-900 font-semibold hover:text-orange-600 transition-colors cursor-pointer"
              >
                Início
              </button>
              <a
                href="#produtos"
                className="text-gray-900 font-semibold hover:text-orange-600 transition-colors cursor-pointer"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Produtos
              </a>
              <a
                href="#sobre"
                className="text-gray-900 font-semibold hover:text-orange-600 transition-colors cursor-pointer"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Sobre
              </a>
              <button
                onClick={() => {
                  handleWhatsAppClick();
                  setIsMobileMenuOpen(false);
                }}
                className="text-left text-gray-900 font-semibold hover:text-orange-600 transition-colors cursor-pointer"
              >
                Contacto
              </button>
              <button
                onClick={() => {
                  handleInstagramClick();
                  setIsMobileMenuOpen(false);
                }}
                className="flex items-center gap-2 text-gray-900 font-semibold hover:text-orange-600 transition-colors cursor-pointer"
              >
                <div className="w-8 h-8 flex items-center justify-center bg-gradient-to-br from-pink-500 to-purple-600 text-white rounded-full">
                  <i className="ri-instagram-line text-lg"></i>
                </div>
                Instagram
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
